module.exports = __webpack_public_path__ + "static/media/location.e23ad0e7.svg";